import React, { useContext } from "react";
import VerticalCylinderTankDisplayImage from "./images/VerticalCylinderTankDisplayImage.png"
import RectangleTankDisplayImage from "./images/RectangleTankDisplayImage.png";
import HorizontalCylinderTankDisplayImage from "./images/HorizontalCylinderTankDisplayImage.png";
import HorizontalOvalTankDisplayImage from "./images/HorizontalOvalTankDisplayImage.png";
import VerticalOvalTankDisplayImage from "./images/VerticalOvalTankDisplayImage.png";
import HorizontalCapsuleTankDisplayImage from "./images/HorizontalCapsuleTankDisplayImage.png";
import VerticalCapsuleTankDisplayImage from "./images/VerticalCapsuleTankDisplayImage.png";
import HorizontalEllipticalTankDisplayImage from "./images/HorizontalEllipticalTankDisplayImage.png";
import HorizontalDishEndsTankDisplayImage from "./images/HorizontalDishEndsTankDisplayImage.png";
import { DashboardContext } from "../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
const LiquidLevelWidgets = ({ selectedWidgetBundle, setSelectedWidgetBundle }) =>{
    const {setShowWidgetsLibrary, setSelectedNewWidgetWindow} = useContext(DashboardContext);
    if(selectedWidgetBundle !== 'liquid_level') return null;
    return(
        <div className="widgets-library-container" style={{zIndex:"10"}}>
            <div className="widgets-library-header-container">
                <div style={{display:"flex",alignItems:"center"}}>
                    <p
                        style={{fontWeight:"bold",fontSize:"25px",marginRight:"10px"}}
                        onClick={() => setSelectedWidgetBundle('')}
                    >&#8592;</p>
                    <h3>Liquid level: Select widget</h3>
                </div>
                <p onClick={() =>{
                    setSelectedWidgetBundle('');
                    setShowWidgetsLibrary(false);
                }}>&#10006;</p>
            </div>
            <div className="widgets-library-body-container">
                <div className="widgets-library-grid">
                    <div className="widgets-bundle-container"
                        onClick={() => {
                            setSelectedWidgetBundle('');
                            setShowWidgetsLibrary(false);
                            setSelectedNewWidgetWindow('vertical_cylinder_tank');
                        }}>
                        <h4>Vertical cylinder tank</h4>
                        <img src={VerticalCylinderTankDisplayImage} alt="Chart" style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Rectangle tank</h4>
                        <img src={RectangleTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal cylinder tank</h4>
                        <img src={HorizontalCylinderTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal ellipse tank</h4>
                        <img src={HorizontalCylinderTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal oval tank</h4>
                        <img src={HorizontalOvalTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Vertical oval tank</h4>
                        <img src={VerticalOvalTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal capsule tank</h4>
                        <img src={HorizontalCapsuleTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Vertical capsule tank</h4>
                        <img src={VerticalCapsuleTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal 2:1 elliptical tank</h4>
                        <img src={HorizontalEllipticalTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Horizontal dish ends tank</h4>
                        <img src={HorizontalDishEndsTankDisplayImage} style={{height:'120px'}}/>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LiquidLevelWidgets;